var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeef(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_319)",
    filter: "url(#filter0_d_641_319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9937 16.1735C39.9844 13.7956 38.5443 11.5264 35.6055 9.82973C29.0978 6.07251 17.7307 6.54368 10.2163 10.8822C6.14995 13.2298 4.0495 16.2286 4.0052 19.0819L4 19.0824V20.5083L4.00513 20.5079C4.01596 22.8843 5.4561 25.152 8.39334 26.8478C14.901 30.605 26.2681 30.1338 33.7826 25.7954C37.9035 23.4161 40.0049 20.3683 39.9936 17.4807L39.9982 17.4803V16.1731L39.9937 16.1735Z",
    fill: "url(#paint0_linear_641_319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2447 27.8539C33.1655 26.645 40.6536 21.115 39.9696 15.5024C39.2857 9.88973 30.6888 6.31976 20.768 7.52865C10.8471 8.73753 3.35911 14.2675 4.04303 19.8802C4.72695 25.4928 13.3238 29.0628 23.2447 27.8539Z",
    fill: "#E9E5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8292 23.2371C24.836 26.12 17.2827 26.4331 12.9584 23.9365C8.63411 21.4399 9.17643 17.079 14.1697 14.1961C19.1629 11.3132 26.7162 11.0002 31.0405 13.4968C35.3647 15.9933 34.8225 20.3543 29.8292 23.2371Z",
    fill: "url(#paint1_linear_641_319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1708 15.6617C19.164 12.7788 26.7174 12.4657 31.0416 14.9624C32.6987 15.9191 33.6403 17.1497 33.8915 18.466C34.2329 16.6184 33.3033 14.8026 31.0416 13.4968C26.7173 11.0001 19.164 11.3132 14.1708 14.1961C11.091 15.9742 9.7054 18.3144 10.1096 20.4329C10.421 18.748 11.7892 17.0367 14.1708 15.6617Z",
    fill: "url(#paint2_linear_641_319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0278 13.6531C35.0278 13.6495 35.0278 13.6459 35.0278 13.6423V12.8261L34.6301 12.7525C34.5008 12.6198 34.3423 12.4981 34.1565 12.3906C34.2829 12.171 34.3485 11.9465 34.3523 11.7263L34.3525 11.726V10.8845L21.1582 12.6442V13.4511L21.1584 13.4513C21.1544 13.8869 21.3967 14.288 21.8336 14.5985V15.3839V15.3856V15.4126L21.8345 15.4124C21.8358 15.8836 22.1204 16.3332 22.7028 16.6695C23.5666 17.1682 24.8627 17.2903 26.0718 17.0582C26.8785 17.5231 28.1447 17.6969 29.4405 17.4476C30.7364 17.1982 31.7313 16.5892 32.1353 15.8913C33.344 15.6581 34.3988 15.0837 34.8307 14.3355C34.9629 14.1066 35.0261 13.8793 35.0276 13.6607H35.0278V13.6531Z",
    fill: "url(#paint3_linear_641_319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.831 13.5021C35.2629 12.754 34.9618 12.023 34.1568 11.5572C34.5587 10.8592 34.3474 10.1109 33.4835 9.61209C32.6195 9.11329 31.3235 8.9913 30.1144 9.22333C29.3076 8.7585 28.0415 8.58468 26.7456 8.83408C25.4498 9.08348 24.4548 9.69246 24.0508 10.3903C22.8421 10.6235 21.7873 11.198 21.3554 11.9461C20.9235 12.6942 21.2245 13.4253 22.0297 13.891C21.6277 14.5891 21.8391 15.3374 22.703 15.8362C23.5669 16.3349 24.8629 16.4569 26.072 16.2249C26.8788 16.6897 28.1449 16.8636 29.4408 16.6142C30.7366 16.3648 31.7315 15.7559 32.1356 15.058C33.3442 14.8247 34.399 14.2503 34.831 13.5021Z",
    fill: "url(#paint4_linear_641_319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0933 11.437L5.94141 17.4911V19.6171L5.94176 19.617C5.93086 20.6101 6.51628 21.5605 7.72263 22.2761C10.4335 23.8843 15.3456 23.645 18.519 21.8127L24.5903 18.3075C26.8859 16.9821 28.0858 15.2709 28.0917 13.6537L28.0933 13.6533V11.437Z",
    fill: "url(#paint5_linear_641_319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7918 8.06356C22.2212 5.93942 15.8914 6.18389 11.7183 8.59329C9.85535 9.66879 8.73991 10.9925 8.40304 12.3118C8.13396 13.3656 7.65203 14.4202 6.80407 15.4137C5.41856 17.0372 5.68589 18.9142 7.7227 20.1225C10.4335 21.7307 15.3456 21.4913 18.5191 19.6591L24.5903 16.1539C28.7101 13.7753 29.306 10.1541 25.7918 8.06356Z",
    fill: "url(#paint6_linear_641_319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7918 8.06356C22.2212 5.93942 15.8914 6.18389 11.7183 8.59329C9.85535 9.66879 8.73991 10.9925 8.40311 12.3118C8.13403 13.3656 7.6521 14.4202 6.80407 15.4137C5.41856 17.0372 5.68589 18.9142 7.7227 20.1225C10.4335 21.7307 15.3456 21.4913 18.5191 19.6591L24.5903 16.1539C28.7101 13.7753 29.3059 10.1541 25.7918 8.06356ZM17.5129 19.0782C16.2775 19.7914 14.624 20.2364 12.9765 20.2991C11.3628 20.3606 9.91371 20.062 8.89643 19.4585C7.31116 18.5181 7.02421 17.0465 8.16532 15.7096C9.02137 14.7065 9.59646 13.5964 9.92348 12.3159C10.2179 11.1629 11.2127 10.0471 12.7246 9.17421C14.4321 8.18843 16.6127 7.59872 18.8648 7.51378C21.1165 7.42885 23.1593 7.85958 24.617 8.72681C27.5568 10.4757 27.0934 13.5469 23.5841 15.573L17.5129 19.0782Z",
    fill: "#AB8A97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8957 12.3802L18.8613 8.89625C18.5686 8.72729 18.2081 8.72729 17.9154 8.89625C17.6714 9.03709 17.6714 9.38921 17.9154 9.53005L23.9498 13.014C24.2425 13.183 24.603 13.183 24.8957 13.014C25.1397 12.8732 25.1397 12.5211 24.8957 12.3802Z",
    fill: "#71525E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4743 13.7883L15.8183 9.92408C15.5256 9.75512 15.1651 9.75512 14.8724 9.92408C14.6285 10.0649 14.6285 10.417 14.8724 10.5579L21.5285 14.4221C21.8211 14.5911 22.1817 14.5911 22.4743 14.4221C22.7183 14.2813 22.7183 13.9292 22.4743 13.7883Z",
    fill: "#71525E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0515 15.1965L13.6094 11.4629C13.3167 11.2939 12.9562 11.2939 12.6635 11.4629C12.4195 11.6037 12.4195 11.9559 12.6635 12.0967L19.1056 15.8303C19.3982 15.9993 19.7588 15.9993 20.0514 15.8303C20.2954 15.6895 20.2954 15.3373 20.0515 15.1965Z",
    fill: "#71525E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6276 16.6046L12.2968 13.5178C12.0042 13.3489 11.6436 13.3489 11.351 13.5178C11.107 13.6587 11.107 14.0108 11.351 14.1516L16.6818 17.2383C16.9744 17.4073 17.335 17.4073 17.6276 17.2383C17.8716 17.0976 17.8716 16.7455 17.6276 16.6046Z",
    fill: "#71525E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2265 18.0126L11.0292 15.5767C10.7366 15.4077 10.376 15.4077 10.0834 15.5767C9.83939 15.7175 9.83939 16.0696 10.0834 16.2105L14.2806 18.6464C14.5733 18.8153 14.9338 18.8153 15.2265 18.6464C15.4704 18.5055 15.4704 18.1534 15.2265 18.0126Z",
    fill: "#71525E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0176 22.4713V23.8757C17.0176 24.0845 17.129 24.2775 17.3098 24.3819L18.6047 25.1656C18.8101 25.2842 19.0631 25.2842 19.2684 25.1656L25.2098 21.7348C25.3907 21.6303 25.502 21.4374 25.502 21.2286V19.8242L17.0176 22.4713Z",
    fill: "url(#paint7_linear_641_319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0176 22.4713L24.2468 18.2969L25.5021 19.8242L19.2684 23.4239C19.0631 23.5424 18.8101 23.5424 18.6047 23.4239L17.0176 22.4713Z",
    fill: "#FAEC8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.502 17.6291V19.0334C25.502 19.2422 25.6134 19.4352 25.7942 19.5396L27.0891 20.3234C27.2945 20.4419 27.5475 20.4419 27.7528 20.3234L33.6942 16.8925C33.875 16.7881 33.9864 16.5951 33.9864 16.3863V14.9819L25.502 17.6291Z",
    fill: "url(#paint8_linear_641_319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.502 17.629L32.7311 13.4546L33.9865 14.9819L27.7529 18.5816C27.5475 18.7001 27.2945 18.7001 27.0892 18.5816L25.502 17.629Z",
    fill: "#FAEC8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9824 18.3927V19.7971C28.9824 20.0059 29.0939 20.1988 29.2747 20.3033L30.5697 21.087C30.775 21.2056 31.028 21.2056 31.2333 21.087L37.1747 17.6561C37.3556 17.5517 37.467 17.3588 37.467 17.15V15.7456L28.9824 18.3927Z",
    fill: "url(#paint9_linear_641_319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9824 18.3927L36.2116 14.2183L37.467 15.7456L31.2333 19.3452C31.028 19.4638 30.775 19.4638 30.5697 19.3452L28.9824 18.3927Z",
    fill: "#FAEC8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4453 22.8451V24.2495C21.4453 24.4583 21.5568 24.6512 21.7376 24.7557L23.0325 25.5394C23.2379 25.658 23.4909 25.658 23.6962 25.5394L29.6376 22.1085C29.8185 22.0041 29.9299 21.8112 29.9299 21.6024V20.198L21.4453 22.8451Z",
    fill: "url(#paint10_linear_641_319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4453 22.8451L28.6745 18.6707L29.9299 20.198L23.6962 23.7976C23.4908 23.9162 23.2379 23.9162 23.0325 23.7976L21.4453 22.8451Z",
    fill: "#FAEC8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2734 19.1564V20.5608C22.2734 20.7696 22.3848 20.9625 22.5657 21.0669L23.8607 21.8507C24.0661 21.9693 24.319 21.9693 24.5244 21.8507L30.4658 18.4198C30.6466 18.3154 30.758 18.1225 30.758 17.9136V16.5093L22.2734 19.1564Z",
    fill: "url(#paint11_linear_641_319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2734 19.1564L29.5026 14.9819L30.758 16.5093L24.5244 20.1089C24.319 20.2275 24.066 20.2275 23.8607 20.1089L22.2734 19.1564Z",
    fill: "#FAEC8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3281 22.0937V23.498C27.3281 23.7068 27.4396 23.8998 27.6203 24.0042L28.9153 24.788C29.1207 24.9065 29.3737 24.9065 29.579 24.788L35.5204 21.3571C35.7012 21.2527 35.8126 21.0597 35.8126 20.8509V19.4465L27.3281 22.0937Z",
    fill: "url(#paint12_linear_641_319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3281 22.0936L34.5573 17.9192L35.8127 19.4465L29.579 23.0462C29.3737 23.1647 29.1207 23.1647 28.9154 23.0462L27.3281 22.0936Z",
    fill: "#FAEC8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_641_319",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_641_319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_641_319",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_319",
    x1: 11.6262,
    y1: 18.3387,
    x2: 23.4036,
    y2: 18.3387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_641_319",
    x1: 10.0391,
    y1: 18.7166,
    x2: 33.9598,
    y2: 18.7166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_641_319",
    x1: 10.0411,
    y1: 16.122,
    x2: 33.9601,
    y2: 16.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A996EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5BAEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_641_319",
    x1: 37.6833,
    y1: 15.1417,
    x2: 9.6716,
    y2: 11.3648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F878A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06DAAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_641_319",
    x1: 33.3798,
    y1: 16.918,
    x2: 26.1761,
    y2: 1.13086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06DAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#31E0BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5954,
    stopColor: "#6AE9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8592,
    stopColor: "#8DEEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BF0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_641_319",
    x1: 12.0488,
    y1: 17.3925,
    x2: 19.4431,
    y2: 17.3925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71525E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_641_319",
    x1: -2.67673,
    y1: 24.4004,
    x2: 22.0417,
    y2: 10.1292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_641_319",
    x1: 18.5887,
    y1: 22.5394,
    x2: 19.7746,
    y2: 22.5394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_641_319",
    x1: 27.0731,
    y1: 17.6971,
    x2: 28.259,
    y2: 17.6971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_641_319",
    x1: 30.5536,
    y1: 18.4608,
    x2: 31.7395,
    y2: 18.4608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_641_319",
    x1: 23.0164,
    y1: 22.9131,
    x2: 24.2024,
    y2: 22.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_641_319",
    x1: 23.8445,
    y1: 19.2245,
    x2: 25.0305,
    y2: 19.2245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_641_319",
    x1: 28.8993,
    y1: 22.1617,
    x2: 30.0852,
    y2: 22.1617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeef);
export default __webpack_public_path__ + "static/media/beef.7a3f72701b7a570b99d643333c46e94c.svg";
export { ForwardRef as ReactComponent };